import { render, staticRenderFns } from "./collection-order.vue?vue&type=template&id=b817506a&scoped=true"
import script from "./collection-order.vue?vue&type=script&lang=ts"
export * from "./collection-order.vue?vue&type=script&lang=ts"
import style0 from "./collection-order.vue?vue&type=style&index=0&id=b817506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b817506a",
  null
  
)

export default component.exports